import React from 'react';
import './GamingLicenseServices.css';
import { SiCheckmarx } from "react-icons/si";
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";

export default function GamingLicenseMwali () {

    return (
        <main className='main'>

            <IntroSection
                title="Gaming License – Mwali (Comoros)"
                subtitle="Operate Your iGaming Business with MISA Licensing"
                description =
                    "<b>Mwali (Mohéli, Comoros)</b> is a <b>globally recognized offshore jurisdiction</b> offering <b>Gaming & iGaming Licenses</b> under the <b>Mwali International Services Authority (MISA)</b>. With <b>strong regulatory credibility</b> and <b>affordable setup</b>, <b>Mwali</b> is a preferred choice for <b>online casinos</b>, <b>sportsbooks</b>, <b>lotteries</b>, and <b>eSports operators</b>."
                badges={[
                    "Online Casino Licens",
                    "Sportsbook License",
                    "Lottery & Sweepstakes",
                    "eSports & Crypto Gaming",
                ]}
                buttonText="Request a Mwali Gaming License Proposal →"
                buttonLink="/contact"
                imageSrc="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop"
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Mwali?'
                        subtitle="Operating without a license exposes your business to:"
                        blocks={[
                            {
                                subtitle: "With a gaming license, you gain:",
                                items: [
                                    { title: "Global Recognition", text: "respected more than new regulators (Western Sahara, Anjouan)" },
                                    { title: "Better PSP Acceptance", text: "easier to integrate with EMIs & payment gateways" },
                                    { title: "Regulated by MISA", text: "compliance-based, FATF-aligned authority" },
                                    { title: "Cost-Effective", text: "cheaper than Malta or Isle of Man" },
                                    { title: "Multi-Vertical Licensing", text: "cover casino, betting, lottery, and eSports under one license" }
                                ]
                            }
                        ]}
                    />

                    <FeatureCards
                        title='What the License Covers'
                        subtitle='With a Mwali Gaming License, you can operate:'
                        features={
                            [
                                { title: "Online Casino", text: "slots, live dealer, RNG games" },
                                { title: "Sportsbook & Betting", text: "pre-match, live betting, eSports, virtuals" },
                                { title: "Lottery & Sweepstakes", text: "online draws and prize games" },
                                { title: "Poker & Skill Games", text: "online poker, fantasy sports, competitions" },
                                { title: "Crypto Gaming Platforms", text: "tokenized casinos, NFT games, provably fair systems" },
                                { title: "White-Label Platforms", text: "operate multiple brands under one license" }
                            ]
                        }
                    />

                    <LocationTimeline
                        title='Benefits of a Mwali Gaming License'
                        item={
                            [
                                { title: "International Recognition", text: "trusted by PSPs, affiliates, and investors" },
                                { title: "Flexibility", text: "combine casino, sportsbook, and lottery under one framework" },
                                { title: "Payment Access", text: "better integration with Visa/Mastercard and crypto PSPs" },
                                { title: "Compliance-Oriented", text: "AML/KYC aligned with FATF standards" },
                                { title: "Affordable & Fast", text: "lower costs and faster than EU licenses (Malta, Isle of Man)" }
                            ]
                        }
                        end='Each jurisdiction has different costs, timelines, and requirements. We help you select the best option for your business model.'
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                { title: "Consultation & Strategy", text: "choose your vertical (casino, sportsbook, lottery, hybrid)" },
                                { title: "Company Incorporation", text: "establish an IBC in Mwali (Comoros)" },
                                { title: "Compliance Setup", text: "AML/KYC manuals, risk framework, business plan" },
                                { title: "Application Filing", text: "Offshore Advisory submits application to MISA" },
                                { title: "Approval & License Grant", text: "typically within 2–3 weeks" }
                            ]

                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                description: "Timeline & Costs",
                                duration: "2–3 weeks",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Costs",
                                description: "from USD 15,000+.",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "Flexible — not as high as EU regulators.",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Renewal Fees",
                                description: "competitive vs Curaçao, cheaper than Malta.",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Recognized agent with MISA licensing experience" },
                                { text: "End-to-end support: incorporation, compliance, licensing, PSP onboarding" },
                                { text: "Access to white-label casino & sportsbook platforms" },
                                { text: "Crypto payment gateway integration"},
                                { text: "Affiliate program structuring for gaming operators"}
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title='Ready to launch your iGaming platform?'
                         description=
                             "<b>Mwali</b> offers a <b>globally respected offshore license</b> with <b>faster timelines</b> and <b>lower costs</b> than <b>EU regulators</b>."
                         buttonText='Book a Mwali Gaming License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How recognized is a Mwali gaming license?",
        content: [
            { type: "answer", text: "It’s globally recognized and accepted by PSPs, giving it more weight than newer offshore regulators." },
        ],
    },
    {
        question: "Can I run both casino and sportsbook under one license?",
        content: [
            { type: "answer", text: "Yes — Mwali allows multiple verticals under a single license." },
        ],
    },
    {
        question: "Is crypto gaming supported?",
        content: [
            { type: "answer", text: "Yes — tokenized casinos, NFT platforms, and crypto payments are allowed." },
        ],
    },
    {
        question: "How long does it take to get licensed?",
        content: [
            { type: "answer", text: "Usually 8–12 weeks, depending on documentation." },
        ],
    },
    {
        question: "Is capital required?",
        content: [
            { type: "answer", text: "No fixed capital is required like Malta/Isle of Man — only standard incorporation + licensing costs." },
        ],
    },
];

const testimonialsData = [
        {
            quote: "We licensed our casino and sportsbook in Mwali with Offshore Advisory. PSP integration was smooth and recognition is solid.",
            author: "Richard A.",
            role: "iGaming Operator"
        },
        {
            quote: "Mwali was the perfect middle ground between Curaçao and Malta. Offshore Advisory guided us from start to launch.",
            author: "Sofia L.",
            role: "Gaming Entrepreneur"
        }
    ]
;